var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientIcon = function SvgPatientIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.305 17.9329C16.9066 17.9329 16.5807 17.5905 16.5807 17.172C16.5807 13.4438 13.3935 10.4383 9.48188 10.4383C5.57031 10.4383 2.41931 13.4818 2.41931 17.172C2.41931 17.5905 2.09335 17.9329 1.69495 17.9329C1.29655 17.9329 0.970581 17.5905 0.970581 17.172C1.0068 12.6448 4.80972 8.95459 9.5181 8.95459C14.2265 8.95459 18.0294 12.6448 18.0294 17.172C18.0294 17.5905 17.7034 17.9329 17.305 17.9329Z",
    fill: "#565559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45979 4.3049C5.45979 6.5454 7.26727 8.34515 9.50004 8.34515C11.7328 8.34515 13.5403 6.5454 13.5403 4.3049C13.5403 2.0644 11.7328 0.264648 9.50004 0.264648C7.26727 0.264648 5.45979 2.0644 5.45979 4.3049ZM6.84205 4.30476C6.84205 2.87231 8.04704 1.69696 9.50011 1.69696C10.9532 1.69696 12.1582 2.87231 12.1582 4.30476C12.1582 5.73721 10.9532 6.91256 9.50011 6.91256C8.04704 6.91256 6.84205 5.73721 6.84205 4.30476Z",
    fill: "#565559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6163 18.1252C11.1225 18.1252 10.7185 17.7888 10.7185 17.3776V12.7803C10.7185 12.3691 11.1225 12.0327 11.6163 12.0327C12.1101 12.0327 12.5141 12.3691 12.5141 12.7803V17.3776C12.4692 17.7888 12.0652 18.1252 11.6163 18.1252Z",
    fill: "#565559"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7955 16.073H9.20783C8.80411 16.073 8.4738 15.669 8.4738 15.1752C8.4738 14.6814 8.80411 14.2773 9.20783 14.2773H13.8322C14.2359 14.2773 14.5662 14.6814 14.5662 15.1752C14.5662 15.669 14.1992 16.073 13.7955 16.073Z",
    fill: "#565559"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-icon.e91d835d88efcacda00ad93917972b44.svg";